module.exports = __webpack_public_path__ + "static/media/shop.0be503b0.svg";